import React, { createContext, useContext } from 'react';

import type { GlobalSettingsContextValue, GlobalSettingsProviderProps } from 'context/GlobalSettingsContext/types';

const GlobalSettingsContext = createContext<GlobalSettingsContextValue>({} as GlobalSettingsContextValue);

export const GlobalSettingsProvider: React.FC<GlobalSettingsProviderProps> = ({ children, settings }) => {
  return (
    <GlobalSettingsContext.Provider
      value={{
        settings,
      }}
    >
      {children}
    </GlobalSettingsContext.Provider>
  );
};

export const useGlobalSettings = (): GlobalSettingsContextValue => useContext(GlobalSettingsContext);
